// channelTime.js

import { format, isToday, isYesterday } from 'date-fns';

const toDate = (value) => {
  if (!value) return null;
  if (typeof value?.toDate === 'function') return value.toDate();
  if (value instanceof Date) return value;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const toMillis = (value) => {
  const date = toDate(value);
  return date ? date.getTime() : 0;
};

export const getChannelDayKey = (value) => {
  const date = toDate(value);
  return date ? date.toDateString() : '';
};

export const formatChannelDayLabel = (value) => {
  const date = toDate(value);
  if (!date) return '';

  if (isToday(date)) return 'Today';
  if (isYesterday(date)) return 'Yesterday';

  const currentYear = new Date().getFullYear();
  if (date.getFullYear() === currentYear) {
    return format(date, 'MMMM d');
  }

  return format(date, 'MMMM d, yyyy');
};

export const formatChannelRelativeTime = (value) => {
  const date = toDate(value);
  if (!date) return '';

  const now = new Date();
  const diffMs = now.getTime() - date.getTime();

  if (diffMs < 60 * 1000) return 'now';

  const minutes = Math.floor(diffMs / (60 * 1000));
  if (minutes < 60) return `${minutes}m ago`;

  const hours = Math.floor(diffMs / (60 * 60 * 1000));
  if (hours < 24) return `${hours}h ago`;

  return date.toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
  });
};

export const getInitials = (value = '') => {
  const words = String(value || '').trim().split(/\s+/).filter(Boolean);
  if (!words.length) return '?';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return `${words[0][0]}${words[1][0]}`.toUpperCase();
};
